export default "__VITE_ASSET__BelAuBeV__"